import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import moment from 'moment';
export default {
  name: 'EvaluateScoreModal',
  mixins: [ModalFormMixin, GetSiteIdMixin],
  data: function data() {
    return {
      title: '评价与得分表单',
      tableName: 'om_evaluate_score',
      siteName: '',
      siteId: '',
      status: '',
      isOnline: '',
      form_fields: ['isOnline', 'sewageDisposal', 'outNum', 'outValidNum', 'electricUsed', 'drugUsed', 'complaintNum', 'dealNum', 'status'],
      form_fields_time: ['reportDate'],
      validatorRules: {
        reportDate: {
          rules: [{
            required: true,
            message: '请输入统计日期!'
          }]
        }
      }
    };
  },
  props: ['pagePath'],
  watch: {
    currentSiteName: function currentSiteName(newVal, oldVal) {
      this.siteName = newVal;
    }
  },
  created: function created() {},
  methods: {
    handleLineChange: function handleLineChange(e) {
      this.isOnline = e.target.checked;
      this.model.isOnline = e.target.checked == true ? 1 : 2;
    },
    handleStatusChange: function handleStatusChange(e) {
      this.status = e.target.checked;
      this.model.status = e.target.checked == true ? 1 : 2;
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;

      if (this.model.id) {
        this.siteName = this.model.siteName;
      } else {
        this.model.reportDate = new Date().toLocaleDateString();
      }

      this.$nextTick(function () {
        var that = _this;
        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item]) : null;
        });
        that.isOnline = _this.model.isOnline && _this.model.isOnline == 1 ? true : false;
        that.status = _this.model.status && _this.model.status == 1 ? true : false;
        that.form.setFieldsValue(timeVal);
      });
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values); //时间格式化

          formData.reportDate = formData.reportDate ? formData.reportDate.format('YYYY-MM-DD') : null;
          formData.siteId = _this2.model.id ? _this2.model.siteId : _this2.currentSiteId;
          var httpurl = '',
              method = '';

          if (!_this2.model.id) {
            httpurl = _this2.url.add ? _this2.url.add : _this2.pagePath;
            method = 'post';
          } else {
            httpurl = _this2.url.edit ? _this2.url.edit : _this2.pagePath;
            method = 'put';
          }

          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    }
  }
};